
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.21 14.11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f8bf13","d":"M7.15 2v1.82c2.25.57 3.8 2.91 3.08 5.43-.41 1.44-1.61 2.57-3.06 2.93A4.319 4.319 0 011.79 8c0-1.53.81-2.89 2.02-3.65.8-.5 1.33-1.32 1.33-2.26v-.11C2.24 2.43 0 4.96 0 8c0 3.81 3.5 6.82 7.45 5.96 2.2-.48 4.01-2.21 4.56-4.39.93-3.66-1.5-7-4.86-7.57z"}}),_c('path',{attrs:{"fill":"#ce952e","d":"M8.12 7.08L6.65 8.55V.48c0-.64-1-.64-1 0v8.16L4.08 7.07c-.46-.46-1.16.25-.71.71l2.37 2.37c.19.19.52.19.71 0l2.37-2.37c.46-.46-.25-1.16-.71-.71z"}})])
          )
        }
      }
    